import HearingIcon from '@mui/icons-material/Hearing';
import Can from "../../common/Can";
import { Navigate } from "react-router";
import AudibleComponent from "./AudibleComponent";
import { usePermissionContext } from "../../../contexts/ProviderProvider";
import ArchiveComponent from "./ArchiveComponent";

export const Component = () => {
    const { views } = usePermissionContext();
    return (
        <Can action={views.VIEW} items={[views.AUDIBLE]} els={<Navigate to="/ballpark" />}>
            <ArchiveComponent />
        </Can>
    );
}
export const icon = <HearingIcon sx={{ color: "text.primary" }} />;
export const text = "Audible";
export const componentName = "Audible";
export const path = "audible";